import events from "../events/EventsObservable";

export const ACTION_EVENTS = {
    "ACTION_SPIN": "ACTION_SPIN",
    "ACTION_SKIP": "ACTION_SKIP",

    "ACTION_AUTOSTART_STOP": "ACTION_AUTOSTART_STOP",
    "ACTION_FORCESTOP": "ACTION_FORCESTOP",

    "ACTION_MAXBET": "ACTION_MAXBET",
    "ACTION_BET_DEC": "ACTION_BET_DEC",
    "ACTION_BET_INC": "ACTION_BET_INC",

    "ACTION_COIN_DEC": "ACTION_COIN_DEC",
    "ACTION_COIN_INC": "ACTION_COIN_INC",
    "ACTION_LINES_DEC": "ACTION_LINES_DEC",
    "ACTION_LINES_INC": "ACTION_LINES_INC",

    "ACTION_AUTOSTART_OPEN": "ACTION_AUTOSTART_OPEN",
    "ACTION_AUTOSTART_CONTINUE": "ACTION_AUTOSTART_CONTINUE",
    "ACTION_AUTOSTART_CLOSE": "ACTION_AUTOSTART_CLOSE",
    "ACTION_AUTOSTART_CHOOSE": "ACTION_AUTOSTART_CHOOSE",
    "ACTION_BETMENU_OPEN": "ACTION_BETMENU_OPEN",
    "ACTION_BETMENU_CLOSE": "ACTION_BETMENU_CLOSE",
    "ACTION_BURGER_OPEN": "ACTION_BURGER_OPEN",
    "ACTION_BURGER_CLOSE": "ACTION_BURGER_CLOSE",
    "ACTION_SETTINGS_OPEN": "ACTION_SETTINGS_OPEN",
    "ACTION_SETTINGS_CLOSE": "ACTION_SETTINGS_CLOSE",
    "ACTION_SETTINGS_RESET": "ACTION_SETTINGS_RESET",
    "ACTION_SETTINGS_SAVE": "ACTION_SETTINGS_SAVE",

    "ACTION_SLIDER_AUTOSTART_ON_SET": "ACTION_SLIDER_AUTOSTART_ON_SET",
    "ACTION_SLIDER_BET_ON_SET": "ACTION_SLIDER_BET_ON_SET",
    "ACTION_SLIDER_BET_UPDATE": "ACTION_SLIDER_BET_UPDATE",
    "ACTION_SLIDER_COIN_ON_SET": "ACTION_SLIDER_COIN_ON_SET",
    "ACTION_SLIDER_COIN_UPDATE": "ACTION_SLIDER_COIN_UPDATE",
    "ACTION_SLIDER_LINES_ON_SET": "ACTION_SLIDER_LINES_ON_SET",
    "ACTION_SLIDER_SLIDE": "ACTION_SLIDER_SLIDE",

    "ACTION_SOUND_CHOOSE": "ACTION_SOUND_CHOOSE",
    "ACTION_SOUND_TOGGLE": "ACTION_SOUND_TOGGLE",
    "ACTION_INFO_TOGGLE": "ACTION_INFO_TOGGLE",
    "ACTION_INFO_ARROW": "ACTION_INFO_ARROW",
    // "ACTION_STAGE_POINTER_DOWN": "ACTION_STAGE_POINTER_DOWN",
    "ACTION_MESSAGE_BUTTON_CLICK": "ACTION_MESSAGE_BUTTON_CLICK",
    "ACTION_HANDEDNESS_TOGGLE": "ACTION_HANDEDNESS_TOGGLE",

    "ACTION_HOME_BUTTON": "ACTION_HOME_BUTTON",
    "ACTION_PARAGRAPH_OPEN": "ACTION_PARAGRAPH_OPEN",
    "ACTION_PARAGRAPH_CLOSE": "ACTION_PARAGRAPH_CLOSE",
    "ACTION_HISTORY_OPEN": "ACTION_HISTORY_OPEN",
    "ACTION_HISTORY_CLOSE": "ACTION_HISTORY_CLOSE",
    "ACTION_IFRAME_CLOSE": "ACTION_IFRAME_CLOSE",


    "ACTION_GAME_CANVAS_SWIPE_LEFT": "ACTION_GAME_CANVAS_SWIPE_LEFT",
    "ACTION_GAME_CANVAS_SWIPE_RIGHT": "ACTION_GAME_CANVAS_SWIPE_RIGHT",
    "ACTION_GAME_CANVAS_SWIPE_UP": "ACTION_GAME_CANVAS_SWIPE_UP",
    "ACTION_GAME_CANVAS_SWIPE_DOWN": "ACTION_GAME_CANVAS_SWIPE_DOWN",
    "ACTION_GAME_CANVAS_TAP": "ACTION_GAME_CANVAS_TAP",

    "ACTION_PREINFO_CLOSE": "ACTION_PREINFO_CLOSE",
    "ACTION_FULLSCREEN_REQUEST": "ACTION_FULLSCREEN_REQUEST",
    "ACTION_FULLSCREEN_EXIT_REQUEST": "ACTION_FULLSCREEN_EXIT_REQUEST",

    "ACTION_BONUS_WHEEL_STOP": "ACTION_BONUS_WHEEL_STOP",
    "ACTION_RESPONSIBLE_GAMING": "ACTION_RESPONSIBLE_GAMING"
};


export default {
    trigger: function (action: string, data?: any) {
        events.dispatch(action, data);
    }
};